/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_FixtureInputs */

const th_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มการแข่งขัน`)
};

const en_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a fixture`)
};

const ja_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合を追加`)
};

const zh_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加比赛`)
};

const es_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir un partido`)
};

const pt_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar um jogo`)
};

const id_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah pertandingan`)
};

const fr_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un match`)
};

const tl_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magdagdag ng laro`)
};

const vi_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm trận`)
};

const ko_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 추가`)
};

const de_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiel hinzufügen`)
};

const ru_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить матч`)
};

const tr_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç ekle`)
};

const it_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi partita`)
};

const pl_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj mecz`)
};

const uk_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати матч`)
};

const hi_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच जोड़ें`)
};

const ar_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة مباراة`)
};

const ms_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah perlawanan`)
};

const bn_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলা যোগ করুন`)
};

const zh_tw2_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增賽事`)
};

const zh_hk2_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增賽事`)
};

const ur_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ شامل کریں`)
};

const fa_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن بازی`)
};

const sw_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza mchezo`)
};

const nl_add_fixture = /** @type {(inputs: Add_FixtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijd toevoegen`)
};

/**
* | output |
* | --- |
* | "Add a fixture" |
*
* @param {Add_FixtureInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const add_fixture = /** @type {((inputs?: Add_FixtureInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_FixtureInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_add_fixture(inputs)
	if (locale === "ja") return ja_add_fixture(inputs)
	if (locale === "zh") return zh_add_fixture(inputs)
	if (locale === "es") return es_add_fixture(inputs)
	if (locale === "pt") return pt_add_fixture(inputs)
	if (locale === "id") return id_add_fixture(inputs)
	if (locale === "fr") return fr_add_fixture(inputs)
	if (locale === "tl") return tl_add_fixture(inputs)
	if (locale === "vi") return vi_add_fixture(inputs)
	if (locale === "ko") return ko_add_fixture(inputs)
	if (locale === "de") return de_add_fixture(inputs)
	if (locale === "ru") return ru_add_fixture(inputs)
	if (locale === "tr") return tr_add_fixture(inputs)
	if (locale === "it") return it_add_fixture(inputs)
	if (locale === "pl") return pl_add_fixture(inputs)
	if (locale === "uk") return uk_add_fixture(inputs)
	if (locale === "hi") return hi_add_fixture(inputs)
	if (locale === "ar") return ar_add_fixture(inputs)
	if (locale === "ms") return ms_add_fixture(inputs)
	if (locale === "bn") return bn_add_fixture(inputs)
	if (locale === "zh-TW") return zh_tw2_add_fixture(inputs)
	if (locale === "zh-HK") return zh_hk2_add_fixture(inputs)
	if (locale === "ur") return ur_add_fixture(inputs)
	if (locale === "fa") return fa_add_fixture(inputs)
	if (locale === "sw") return sw_add_fixture(inputs)
	if (locale === "nl") return nl_add_fixture(inputs)
	return en_add_fixture(inputs)
});